import {IAppState} from '../../state/AppState';

export const getCurrentOverlay = (state: IAppState) => state.overlays.current;

export const getCurrentOverlayState = (state: IAppState) =>
  state.overlays.currentOverlayState;

export const getPendingOverlays = (state: IAppState) => state.overlays.queue;
